exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-wrap[data-v-3254279e] {\n  margin-top: 12px;\n  text-align: right;\n}\n", ""]);

// exports
